import r from"./_arrayLikeKeys.js";import e from"./_baseKeys.js";import o from"./isArrayLike.js";function s(s){return o(s)?r(s):e(s)}export{s as default};
//# sourceMappingURL=keys.js.map
